module.exports = __webpack_public_path__ + "img/logout_menu_icon.30e62603.png";